import { lazy } from "react"
import { MINE_CHAT_LANG } from "store/apis/mineChatAPI/values"
import { IMessage } from "store/apis/mineChatAPI/mine-chat.types"

export const CHAT_MODALS = {
  messageManagement: {
    component: lazy(() => import("modals/ui/chat/MessageManagementModal")),
    params: {} as {
      chatId: MINE_CHAT_LANG
      message: IMessage
    }
  },
  bannedInChat: {
    component: lazy(() => import("modals/ui/chat/BannedInChatModal"))
  }
} as const
